<div class="container-fluid imprint-container"
     id="imprint-container">
  <div id="content"
       class="row">
    <div class="col-2"></div>
    <div class="col-8 mt-5">
      <h1 style="font-weight: bold">Impressum</h1>

      <!-- Zwei eigenstaendige Bloecke, keine gemeinsame Feldmaske: das
           FPS-Impressum fuehrt weder Aufsichtsratsvorsitz noch zustaendige
           Aufsichtsbehoerde noch Postanschrift noch eine Website-Angabe. -->
      <ng-container *ngIf="authService.getLegalTenant() === 'FPS'; else fgsImprint">
      <p>
        Fraport Passenger Services GmbH<br />
        HBK 173C / 005<br />
        60549 Frankfurt am Main – Flughafen
      </p>

      <p>
        Telefon: +49 69 690 60300<br />
        Telefax: +49 69 690 59952<br />
        E-Mail: <a href="mailto:kontakt&#64;fps-fra.de">kontakt&#64;fps-fra.de</a>
      </p>

      <h3 style="font-weight: bold">Sitz der Gesellschaft</h3>
      <p>
        Frankfurt / Main – Flughafen<br />
        Amtsgericht Frankfurt / Main<br />
        HRB 77886<br />
        Umsatzsteuer-Identifikationsnummer: DE 250787856
      </p>

      <h3 style="font-weight: bold">Geschäftsführung</h3>
      <p>
        Mira Fischer
      </p>
      </ng-container>

      <ng-template #fgsImprint>

      <p>
        Fraport Ground Services GmbH<br />
        CargoCity Nord, Gebäude 458<br />
        60549 Frankfurt am Main – Flughafen
      </p>

      <p>
        Telefon: +49 69 690 70652<br />
        Telefax: +49 69 690 59684<br />
        E-Mail: <a href="mailto:fgs-kontakt&#64;fraport.de">fgs-kontakt&#64;fraport.de</a><br />
        Website: <a href="https://www.fraport-groundservices.com"
           target="_blank"
           rel="noopener">www.fraport-groundservices.com</a>
      </p>

      <h3 style="font-weight: bold">Sitz der Gesellschaft</h3>
      <p>
        Frankfurt / Main – Flughafen<br />
        Amtsgericht Frankfurt / Main<br />
        HRB 58100<br />
        Umsatzsteuer-Identifikationsnummer: DE 232886102
      </p>

      <h3 style="font-weight: bold">Geschäftsführung</h3>
      <p>
        Dr. Markus Kleiner (Vorsitz)<br />
        Jan Eisbrenner
      </p>

      <p>
        Vorsitzende des Aufsichtsrates: Julia Kranenberg
      </p>

      <h3 style="font-weight: bold">Zuständige Aufsichtsbehörde / Erlaubnisbehörde</h3>
      <p>
        Bundesagentur für Arbeit - Agentur für Arbeit Düsseldorf<br />
        Besucheranschrift:<br />
        Grafenberger Allee 300<br />
        40237 Düsseldorf
      </p>

      <h3 style="font-weight: bold">Postanschrift:</h3>
      <p>
        Agentur für Arbeit Düsseldorf<br />
        40180 Düsseldorf<br />
        Tel: +49 211 692 1100<br />
        Fax: +49 211 692-1610<br />
        E-Mail: <a href="mailto:Duesseldorf&#64;arbeitsagentur.de">Duesseldorf&#64;arbeitsagentur.de</a>
      </p>
      </ng-template>
    </div>
  </div>
</div>